/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-lonely-if */
/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
// import PropTypes from 'prop-types';
// components
import { Grid, Button } from '@design-system-coopeuch/web';
import Modal from '../../organisms/Modal/Modal';
import ItemValidation from '../../molecules/ItemValidation/ItemValidation';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
import ContentPasswordCreation from './ContentPasswordCreation';
import ContentAppPassCoopeuch from './ContentAppPassCoopeuch';

// assets
import iconInternetPassword from '../../../assets/img/icon-internet-password.png';
import iconAppCoopeuch from '../../../assets/img/icon-app-coopeuch.png';
import iconPassCooopeuch from '../../../assets/img/icon-pass-coopeuch.png';
import iconPersonSuccess from '../../../assets/img/icon-person-success-female-desktop.svg';

const CardPasswordAndDigitize = (props) => {
  const {
    phone,
    inputCodeSMS,
    password,
    confirmationPassword,
    passwordVisibility,
    confirmationPasswordVisibility,
    stateAuthSms,
    stateCreatingPassword,
    canCreatePassword,
    messagesInputAuthSms,
    storeSelected,
    onChangePasswordVisibility,
    onInvokeAuthSms,
    onTimeOverToRespond,
    onCreatePassword,
    onChange,
    onChangeStoreSelected,
    isOpenCurrentModal,
    nameCurrentModal,
    onCloseCurrentModal,
    onOpenCurrentModal,
    onRedirectToPrivateSite,
  } = props;

  return (
    <>
      <SimpleCard
        contentHeader={
          <article className="d-flex flex-column">
            <p className="simplecard__title">¡Crea tu clave y digitalízate!</p>
            <p className="simplecard__subtitle">
              Realiza tus consultas y transacciones desde tus dispositivos.
            </p>
          </article>
        }
      >
        <Grid row className="d-flex m-0 padding-16 p-md-6">
          <Grid col={12} md={4} className="p-0 pr-md-1">
            <SimpleCard
              className={classNames('simplecard-into-simplecard')}
              contentHeader={
                <p className="font-size-16 font-weight-bold">Crea tu clave de internet</p>
              }
            >
              <Grid className="h-100 d-flex flex-column m-0 py-3 pt-5 pb-4">
                {stateCreatingPassword === 'success' ||
                sessionStorage.getItem('password-already-created') === 'SI' ? (
                  <>
                    <Grid className="d-flex flex-column flex-grow-1 align-items-center pb-4">
                      <img src={iconPersonSuccess} alt="" width="112" />
                      <article className="d-flex flex-column align-items-center">
                        <p className="font-size-16 font-  weight-bold mt-4">¡Genial!</p>
                        <p className="font-size-14 line-height-20 text-center mt-2">
                          Haz creado tu clave de internet con éxito. Ahora podrás comenzar a
                          utilizar los productos digitales que Coopeuch tiene para ti.
                        </p>
                      </article>
                    </Grid>
                    <Grid className="d-flex justify-content-center flex-0-0-10">
                      <Button
                        color="secondary"
                        onClick={() => onRedirectToPrivateSite()}
                        className="w-100"
                        variant=""
                      >
                        Ir a Coopeuch en línea
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid className="d-flex flex-column flex-grow-1 align-items-center pb-4">
                      <img src={iconInternetPassword} alt="" width="112" />
                      <article className="d-flex flex-column align-items-start">
                        <ItemValidation type="success" fontSize="14" className="mt-2">
                          <p className="text-color-black-85 line-height-20">
                            <strong>Crea tu clave</strong> en solo 3 pasos.
                          </p>
                        </ItemValidation>
                        <ItemValidation type="success" fontSize="14" className="mt-2">
                          <p className="text-color-black-85 line-height-20">
                            <strong>Accede a tu App y sitio en línea</strong> cuando quieras.
                          </p>
                        </ItemValidation>
                      </article>
                    </Grid>
                    <Grid className="d-flex justify-content-center flex-0-0-10">
                      <Button
                        color="secondary"
                        onClick={() => onOpenCurrentModal('password')}
                        className="w-100"
                        variant=""
                      >
                        Crear clave
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </SimpleCard>
          </Grid>
          <Grid col={12} md={4} className="p-0 py-2 py-md-0 px-md-2">
            <SimpleCard
              className={classNames('simplecard-into-simplecard')}
              contentHeader={
                <p className="font-size-16 font-weight-bold">Descarga tu App Coopeuch</p>
              }
            >
              <Grid className="h-100 d-flex flex-column m-0 py-3 pt-5 pb-4">
                <Grid className="d-flex flex-column flex-grow-1 align-items-center pb-4">
                  <img src={iconAppCoopeuch} alt="" width="112" />
                  <article className="d-flex flex-column align-items-start">
                    <ItemValidation type="success" fontSize="14" className="mt-2">
                      <p className="text-color-black-85 line-height-20">
                        <strong>Accede a tu App y sitio en línea</strong> cuando quieras.
                      </p>
                    </ItemValidation>
                    <ItemValidation type="success" fontSize="14" className="mt-2">
                      <p className="text-color-black-85 line-height-20">
                        <strong>Transfiere más rápido</strong> a tus contactos.
                      </p>
                    </ItemValidation>
                    <ItemValidation type="success" fontSize="14" className="mt-2">
                      <p className="text-color-black-85 line-height-20">
                        <strong>Bloquea tus tarjetas</strong> de manera sencilla.
                      </p>
                    </ItemValidation>
                  </article>
                </Grid>
                <Grid className="d-flex justify-content-center flex-0-0-10">
                  <Button
                    color="secondary"
                    onClick={() => onOpenCurrentModal('appCoopeuch')}
                    className="w-100"
                    variant="outline"
                  >
                    Descargar AppCoopeuch
                  </Button>
                </Grid>
              </Grid>
            </SimpleCard>
          </Grid>
          <Grid col={12} md={4} className="p-0 pl-md-1">
            <SimpleCard
              className={classNames('simplecard-into-simplecard')}
              contentHeader={
                <p className="font-size-16 font-weight-bold">Descarga tu PassCoopeuch</p>
              }
            >
              <Grid className="h-100 d-flex flex-column m-0 py-3 pt-5 pb-4">
                <Grid className="d-flex flex-column flex-grow-1 align-items-center pb-4">
                  <img src={iconPassCooopeuch} alt="" width="112" />
                  <article className="d-flex flex-column align-items-star pb-2">
                    <ItemValidation type="success" fontSize="14" className="mt-2">
                      <p className="text-color-black-85 line-height-20">
                        <strong>Autoriza tus transacciones</strong> en un solo paso.
                      </p>
                    </ItemValidation>
                    <ItemValidation type="success" fontSize="14" className="mt-2">
                      <p className="text-color-black-85 line-height-20">
                        <strong>Actualiza tus datos</strong> de forma más segura.
                      </p>
                    </ItemValidation>
                  </article>
                </Grid>
                <Grid className="d-flex justify-content-center flex-0-0-10">
                  <Button
                    color="secondary"
                    onClick={() => onOpenCurrentModal('passCoopeuch')}
                    className="w-100"
                    variant="outline"
                  >
                    Descargar PassCoopeuch
                  </Button>
                </Grid>
              </Grid>
            </SimpleCard>
          </Grid>
        </Grid>
      </SimpleCard>
      <Modal isOpen={isOpenCurrentModal} closeModal={onCloseCurrentModal}>
        {nameCurrentModal === 'password' ? (
          <ContentPasswordCreation
            phone={phone}
            password={password}
            confirmationPassword={confirmationPassword}
            inputCodeSMS={inputCodeSMS}
            stateAuthSms={stateAuthSms}
            stateCreatingPassword={stateCreatingPassword}
            passwordVisibility={passwordVisibility}
            confirmationPasswordVisibility={confirmationPasswordVisibility}
            canCreatePassword={canCreatePassword}
            messagesInputAuthSms={messagesInputAuthSms}
            onInvokeAuthSms={onInvokeAuthSms}
            onChange={onChange}
            onTimeOverToRespond={onTimeOverToRespond}
            onCreatePassword={onCreatePassword}
            onChangePasswordVisibility={onChangePasswordVisibility}
            onCloseCurrentModal={onCloseCurrentModal}
          />
        ) : (
          <>
            {nameCurrentModal && (
              <ContentAppPassCoopeuch
                nameCurrentModal={nameCurrentModal}
                storeSelected={storeSelected}
                onChangeStoreSelected={onChangeStoreSelected}
              />
            )}
          </>
        )}
      </Modal>
    </>
  );
};

CardPasswordAndDigitize.defaultProps = {};
CardPasswordAndDigitize.propTypes = {};

export default CardPasswordAndDigitize;
